import UploadPresentationVideoComponent from "./UploadPresentationVideoComponent"

export default UploadPresentationVideoComponent;